// EASY DIFFICULTY
export const Easy=[
    {
        question:"Which South American country was named after the Italian city of Venice?",
        answers:[
            {text:"Colombia",isCorrect:false},
            {text:"Bolivia",isCorrect:false},
            {text:"Venezuela",isCorrect:true},
            {text:"Paraguay",isCorrect:false},
        ]
    },
    {
        question:"Who won the Rugby World Cup in 2007?",
        answers:[
            {text:"UK",isCorrect:false},
            {text:"USA",isCorrect:false},
            {text:"South Africa",isCorrect:true},
            {text:"Russia",isCorrect:false},
        ]
    },
    {
        question:"Which football team are nicknamed the Rams?",
        answers:[
            {text:"Westham United",isCorrect:false},
            {text:"Derby County",isCorrect:true},
            {text:"Aston Villa",isCorrect:false},
            {text:"Chelsea",isCorrect:false},
        ]
    },
    {
        question:"What is the hardest natural substance?",
        answers:[
            {text:"Diamond",isCorrect:true},
            {text:"Copper",isCorrect:false},
            {text:"Iron",isCorrect:false},
            {text:"Gold",isCorrect:false},
        ]
    },
    {
        question:"How many different scoring areas are there on a standard dart board?",
        answers:[
            {text:"100",isCorrect:false},
            {text:"99",isCorrect:false},
            {text:"82",isCorrect:true},
            {text:"85",isCorrect:false},
        ]
    },
    {
        question:"Who directed the 1976 film Taxi Driver?",
        answers:[
            {text:"Stanley Kubrick",isCorrect:false},
            {text:"Martin Scorsese",isCorrect:true},
            {text:"Ridley Scott",isCorrect:false},
            {text:"Christopher Nolan",isCorrect:false},
        ]
    },
    {
        question:"The pop groups Ace Of Base and The Cardigans both hail from which country?",
        answers:[
            {text:"USA",isCorrect:false},
            {text:"Germany",isCorrect:false},
            {text:"Italy",isCorrect:false},
            {text:"Sweden",isCorrect:true},
        ]
    },
    {
        question:"What colour are the shorts that Bart Simpson normally wears?",
        answers:[
            {text:"Red",isCorrect:false},
            {text:"Yellow",isCorrect:false},
            {text:"Green",isCorrect:false},
            {text:"Blue",isCorrect:true},
        ]
    },
    {
        question:"In which country would you find the Mojave Desert?",
        answers:[
            {text:"Turkey",isCorrect:false},
            {text:"Italy",isCorrect:false},
            {text:"France",isCorrect:false},
            {text:"USA",isCorrect:true},
        ]
    },
    {
        question:"In terms of land area, what was the largest empire of all time?",
        answers:[
            {text:"Mongol Empire",isCorrect:false},
            {text:"British Empire",isCorrect:true},
            {text:"Ottoman Empire",isCorrect:false},
            {text:"Abbasid Caliphate",isCorrect:false},
        ]
    },
    {
        question:"Genghis Khan founded which empire?",
        answers:[
            {text:"Persian Empire",isCorrect:false},
            {text:"Timurid Empire",isCorrect:false},
            {text:"Hunnic Empire",isCorrect:false},
            {text:"Mongol Empire",isCorrect:true},
        ]
    },
    {
        question:"What is a more common name for the Aurora Borealis?",
        answers:[
            {text:"The Eastern Lights",isCorrect:false},
            {text:"The Western Lights",isCorrect:false},
            {text:"The Southern Lights",isCorrect:false},
            {text:"The Northern Lights",isCorrect:true},
        ]
    },
    {
        question:"Who painted the famous painting The Scream?",
        answers:[
            {text:"Edward Munch",isCorrect:true},
            {text:"Vincent van Gogh",isCorrect:false},
            {text:"Claude Monet",isCorrect:false},
            {text:"Salvador Dali",isCorrect:false},
        ]
    },
    {
        question:"What is the lightest chemical element?",
        answers:[
            {text:"Iron",isCorrect:false},
            {text:"Hellium",isCorrect:false},
            {text:"Hydrogen",isCorrect:true},
            {text:"Gallium",isCorrect:false},
        ]
    },
    {
        question:"By what name is the Sodium Chloride more commonly known?",
        answers:[
            {text:"Salt",isCorrect:true},
            {text:"Sugar",isCorrect:false},
            {text:"Vinegar",isCorrect:false},
            {text:"Saltpeter",isCorrect:false},
        ]
    },
    {
        question:"Who wrote War and Peace?",
        answers:[
            {text:"Lev Tolstoy",isCorrect:true},
            {text:"Franz Kafka",isCorrect:false},
            {text:"George Orwell",isCorrect:false},
            {text:"Stephen King",isCorrect:false},
        ]
    },
    {
        question:"Which Carthaginian general led his army across the Alps with a contingent of elephants?",
        answers:[
            {text:"Mago",isCorrect:false},
            {text:"Phameas",isCorrect:false},
            {text:"Bomilcar",isCorrect:false},
            {text:"Hannibal",isCorrect:true},
        ]
    },
    {
        question:"Which bird can run the fastest?",
        answers:[
            {text:"Ostrich",isCorrect:true},
            {text:"Chicken",isCorrect:false},
            {text:"Duck",isCorrect:false},
            {text:"Penguin",isCorrect:false},
        ]
    },
    {
        question:"Which artist painted the famous `Sunflowers`?",
        answers:[
            {text:"Edward Munch",isCorrect:false},
            {text:"Vincent van Gogh",isCorrect:true},
            {text:"Claude Monet",isCorrect:false},
            {text:"Salvador Dali",isCorrect:false},
        ]
    },
    {
        question:"From what stone is the Taj Mahal built?",
        answers:[
            {text:"Limestone",isCorrect:false},
            {text:"Marble",isCorrect:true},
            {text:"Granite",isCorrect:false},
            {text:"Dolomite",isCorrect:false},
        ]
    },
    {
        question:"In which decade was the film `Grease` set?",
        answers:[
            {text:"1950s",isCorrect:true},
            {text:"1960s",isCorrect:false},
            {text:"1940s",isCorrect:false},
            {text:"1970s",isCorrect:false},
        ]
    },
    {
        question:"If Superman works for the Daily Planet who works for the Daily Bugle?",
        answers:[
            {text:"Spiderman",isCorrect:true},
            {text:"Batman",isCorrect:false},
            {text:"Deadpool",isCorrect:false},
            {text:"Captain America",isCorrect:false},
        ]
    },
    {
        question:"What is the world`s largest lake?",
        answers:[
            {text:"The Baikal",isCorrect:false},
            {text:"The Caspian Sea",isCorrect:true},
            {text:"The Victoria",isCorrect:false},
            {text:"The Michigan",isCorrect:false},
        ]
    },
    {
        question:"In which country is the town of Tequila?",
        answers:[
            {text:"Mexico",isCorrect:true},
            {text:"Canada",isCorrect:false},
            {text:"Sweden",isCorrect:false},
            {text:"Spain",isCorrect:false},
        ]
    },
    {
        question:"`Hakuna Matata` was a song from which 1994 Disney film?",
        answers:[
            {text:"Bambi",isCorrect:false},
            {text:"Robin Hood",isCorrect:false},
            {text:"Sleeping Beauty",isCorrect:false},
            {text:"Lion King",isCorrect:true},
        ]
    },
];

// MEDIUM DIFFICULTY
export const Medium=[
    {
        question:"By number of films made which country has the largest film industry?",
        answers:[
            {text:"UK",isCorrect:false},
            {text:"India",isCorrect:true},
            {text:"Spain",isCorrect:false},
            {text:"Russia",isCorrect:false},
        ]
    },
    {
        question:"What is the capital of India?",
        answers:[
            {text:"Pune",isCorrect:false},
            {text:"Jaipur",isCorrect:false},
            {text:"New Delhi",isCorrect:true},
            {text:"Nagpur",isCorrect:false},
        ]
    },
    {
        question:"Which country had a secret police force known as the Tonton Macoute?",
        answers:[
            {text:"Morocco",isCorrect:false},
            {text:"Mexico",isCorrect:false},
            {text:"India",isCorrect:false},
            {text:"Haiti",isCorrect:true},
        ]
    },
    {
        question:"In the board game Risk, what colour is Europe?",
        answers:[
            {text:"Green",isCorrect:false},
            {text:"Red",isCorrect:false},
            {text:"Yellow",isCorrect:false},
            {text:"Blue",isCorrect:true},
        ]
    },
    {
        question:"Which country was the first FIFA world cup held?",
        answers:[
            {text:"Uruguay",isCorrect:true},
            {text:"Spain",isCorrect:false},
            {text:"Brazil",isCorrect:false},
            {text:"Japan",isCorrect:false},
        ]
    },
    {
        question:"According to Shakespeare, whose horse was called White Surrey?",
        answers:[
            {text:"Richard I's",isCorrect:false},
            {text:"Richard III's",isCorrect:true},
            {text:"William I's",isCorrect:false},
            {text:"Alfred II's",isCorrect:false},
        ]
    },
    {
        question:"In which county was Isaac Newton born?",
        answers:[
            {text:"York",isCorrect:false},
            {text:"Manchester",isCorrect:false},
            {text:"Lincolnshire",isCorrect:true},
            {text:"Bolton",isCorrect:false},
        ]
    },
    {
        question:"What state does Sarah Palin represent as its governor?",
        answers:[
            {text:"Hawaii",isCorrect:false},
            {text:"Alaska",isCorrect:true},
            {text:"Washington",isCorrect:false},
            {text:"Los Angeles",isCorrect:false},
        ]
    },
    {
        question:"In which year did Royal Mail introduce self adhesive stamps?",
        answers:[
            {text:"2003",isCorrect:false},
            {text:"2001",isCorrect:true},
            {text:"2007",isCorrect:false},
            {text:"2005",isCorrect:false},
        ]
    },
    {
        question:"Which world famous musician was born Farrokh Bulsara in Zanzibar in 1946?",
        answers:[
            {text:"Prince",isCorrect:false},
            {text:"Marvin Gaye",isCorrect:false},
            {text:"Freddie Mercury",isCorrect:true},
            {text:"Louis Armstrong",isCorrect:false},
        ]
    },
    {
        question:"A country historically known as Abyssinia, what is the modern name for it?",
        answers:[
            {text:"Iraq",isCorrect:false},
            {text:"Syria",isCorrect:false},
            {text:"Egypt",isCorrect:false},
            {text:"Ethiopia",isCorrect:true},
        ]
    },
    {
        question:"What country was formerly known as Persia?",
        answers:[
            {text:"Syria",isCorrect:false},
            {text:"Iran",isCorrect:true},
            {text:"Egypt",isCorrect:false},
            {text:"Morocco",isCorrect:false},
        ]
    },
    {
        question:"Who wrote the Waverley novels?",
        answers:[
            {text:"Sir Walter Scott",isCorrect:true},
            {text:"Lev Tolstoy",isCorrect:false},
            {text:"James Joyce",isCorrect:false},
            {text:"John Steinbeck",isCorrect:false},
        ]
    },
    {
        question:"What is the capital city of Tasmania?",
        answers:[
            {text:"Delhi",isCorrect:false},
            {text:"Hobart",isCorrect:true},
            {text:"Devonport",isCorrect:false},
            {text:"Evandale",isCorrect:false},
        ]
    },
    {
        question:"In what year was the Great Train Robbery?",
        answers:[
            {text:"1959",isCorrect:false},
            {text:"1964",isCorrect:false},
            {text:"1963",isCorrect:true},
            {text:"1958",isCorrect:false},
        ]
    },
    {
        question:"What country has the largest coastline?",
        answers:[
            {text:"France",isCorrect:false},
            {text:"Sweden",isCorrect:false},
            {text:"Canada",isCorrect:true},
            {text:"Denmark",isCorrect:false},
        ]
    },
    {
        question:"What is the maximum number of horses allowed to run in the Grand National?",
        answers:[
            {text:"10",isCorrect:false},
            {text:"20",isCorrect:false},
            {text:"30",isCorrect:false},
            {text:"40",isCorrect:true},
        ]
    },
    {
        question:"Which football team are known as the Rosso-nera or Rosso-Neri?",
        answers:[
            {text:"Juventus",isCorrect:false},
            {text:"Milan",isCorrect:true},
            {text:"Roma",isCorrect:false},
            {text:"Venezia",isCorrect:false},
        ]
    },
    {
        question:"What nationality is the singer Feist?",
        answers:[
            {text:"Russia",isCorrect:false},
            {text:"Canada",isCorrect:true},
            {text:"UK",isCorrect:false},
            {text:"Italy",isCorrect:false},
        ]
    },
    {
        question:"The 1812 Overture was written to celebrate the defeat of Napoleon in which city?",
        answers:[
            {text:"Paris",isCorrect:false},
            {text:"Moscow",isCorrect:true},
            {text:"Berlin",isCorrect:false},
            {text:"Qazan",isCorrect:false},
        ]
    },
    {
        question:"In which city was Terry Waite kidnapped?",
        answers:[
            {text:"Paris",isCorrect:false},
            {text:"Moscow",isCorrect:false},
            {text:"Qazan",isCorrect:false},
            {text:"Beirut",isCorrect:true},
        ]
    },
    {
        question:"Which football team has the nickname of the Bluebirds?",
        answers:[
            {text:"Chelsea",isCorrect:false},
            {text:"Cardiff City",isCorrect:true},
            {text:"Liverpool",isCorrect:false},
            {text:"Manchester City",isCorrect:false},
        ]
    },
    {
        question:"Which South American country will host the 2014 FIFA World Cup?",
        answers:[
            {text:"Ecuador",isCorrect:false},
            {text:"Brazil",isCorrect:true},
            {text:"Uruguay",isCorrect:false},
            {text:"Paraguay",isCorrect:false},
        ]
    },
    {
        question:"In which country would you find the Barossa Valley?",
        answers:[
            {text:"Australia",isCorrect:true},
            {text:"Finland",isCorrect:false},
            {text:"Austria",isCorrect:false},
            {text:"Hungary",isCorrect:false},
        ]
    },
    {
        question:"In which century did the Mary Rose sink?",
        answers:[
            {text:"15th",isCorrect:false},
            {text:"16th",isCorrect:true},
            {text:"17th",isCorrect:false},
            {text:"19th",isCorrect:false},
        ]
    },
];

// HARD DIFFICULTY
export const Hard=[
    {
        question:"How many emirates make up the United Arab Emirates?",
        answers:[
            {text:"5",isCorrect:false},
            {text:"12",isCorrect:false},
            {text:"10",isCorrect:false},
            {text:"7",isCorrect:true},
        ]
    },
    {
        question:"Who won the 2009 Rugby World Sevens Cup?",
        answers:[
            {text:"Wales",isCorrect:true},
            {text:"Scotland",isCorrect:false},
            {text:"England",isCorrect:false},
            {text:"USA",isCorrect:false},
        ]
    },
    {
        question:"In which sport are the Thomas Cup, Uber Cup and Sudiman Cup tournaments played?",
        answers:[
            {text:"Soccer",isCorrect:false},
            {text:"Badminton",isCorrect:true},
            {text:"Tennis",isCorrect:false},
            {text:"Rugby",isCorrect:false},
        ]
    },
    {
        question:"How many wings does a bee have?",
        answers:[
            {text:"2",isCorrect:false},
            {text:"3",isCorrect:false},
            {text:"4",isCorrect:true},
            {text:"6",isCorrect:false},
        ]
    },
    {
        question:"In what American state was Barack Obama born?",
        answers:[
            {text:"Georgia",isCorrect:false},
            {text:"Alabama",isCorrect:false},
            {text:"Hawaii",isCorrect:true},
            {text:"Michigan",isCorrect:false},
        ]
    },
    {
        question:"What was Barack Obama`s father`s first name?",
        answers:[
            {text:"Nick",isCorrect:false},
            {text:"James",isCorrect:false},
            {text:"Barack",isCorrect:true},
            {text:"John",isCorrect:false},
        ]
    },
    {
        question:"Which fruit contains the most calories?",
        answers:[
            {text:"Apple",isCorrect:false},
            {text:"Orange",isCorrect:false},
            {text:"Avocado",isCorrect:true},
            {text:"Pineapple",isCorrect:false},
        ]
    },
    {
        question:"In which British city did the Peterloo massacre take place in 1819?",
        answers:[
            {text:"York",isCorrect:false},
            {text:"London",isCorrect:false},
            {text:"Sheffield",isCorrect:false},
            {text:"Machester",isCorrect:true},
        ]
    },
    {
        question:"How is soccer superstar Ricardo Izecson dos Santos Leite better known?",
        answers:[
            {text:"Neymar",isCorrect:false},
            {text:"Ronaldinho",isCorrect:false},
            {text:"Ronaldo",isCorrect:false},
            {text:"Kaka",isCorrect:true},
        ]
    },
    {
        question:"Which country did Celine Dion represent when singing in the Eurovision Song Contest in 1988?",
        answers:[
            {text:"Switzerland",isCorrect:true},
            {text:"Sweden",isCorrect:false},
            {text:"France",isCorrect:false},
            {text:"Italy",isCorrect:false},
        ]
    },
    {
        question:"On which planet is the solar system`s highest volcano?",
        answers:[
            {text:"Mars",isCorrect:true},
            {text:"Venus",isCorrect:false},
            {text:"Earth",isCorrect:false},
            {text:"Mercury",isCorrect:false},
        ]
    },
    {
        question:"Which country`s national flag has the most colours?",
        answers:[
            {text:"USA",isCorrect:false},
            {text:"South Africa",isCorrect:true},
            {text:"France",isCorrect:false},
            {text:"China",isCorrect:false},
        ]
    },
    {
        question:"Who played the role of Mr Freeze in the film Batman And Robin?",
        answers:[
            {text:"Hugh Jackman",isCorrect:false},
            {text:"Liam Neeson",isCorrect:false},
            {text:"Tom Cruise",isCorrect:false},
            {text:"Arnold Schwarzenegger",isCorrect:true},
        ]
    },
    {
        question:"In which African country is Mount Kilimanjaro?",
        answers:[
            {text:"Algeria",isCorrect:false},
            {text:"Morocco",isCorrect:false},
            {text:"Ethiopia",isCorrect:false},
            {text:"Tanzania",isCorrect:true},
        ]
    },
    {
        question:"In Roman mythology, who was the ruler of the Gods?",
        answers:[
            {text:"Jupiter",isCorrect:true},
            {text:"Venus",isCorrect:false},
            {text:"Mars",isCorrect:false},
            {text:"Mercury",isCorrect:false},
        ]
    },
    {
        question:"What year was the first motor race held that was classed as Formula 1?",
        answers:[
            {text:"1920",isCorrect:false},
            {text:"1930",isCorrect:false},
            {text:"1940",isCorrect:false},
            {text:"1950",isCorrect:true},
        ]
    },
    {
        question:"Which King of England was crowned on Christmas Day?",
        answers:[
            {text:"Alfred I",isCorrect:false},
            {text:"William I",isCorrect:true},
            {text:"Richard I",isCorrect:false},
            {text:"Richard II",isCorrect:false},
        ]
    },
    {
        question:"In which year did Pablo Picasso die?",
        answers:[
            {text:"1967",isCorrect:false},
            {text:"1969",isCorrect:false},
            {text:"1971",isCorrect:false},
            {text:"1973",isCorrect:true},
        ]
    },
    {
        question:"Still in use today, which country`s flag is the oldest in the world?",
        answers:[
            {text:"Germany",isCorrect:false},
            {text:"Denmark",isCorrect:true},
            {text:"Turkey",isCorrect:false},
            {text:"China",isCorrect:false},
        ]
    },
    {
        question:"When viewed at a certain angle, the 1553 painting: `The Ambassadors` reveals which mysterious object?",
        answers:[
            {text:"A Pencil",isCorrect:false},
            {text:"A Knife",isCorrect:false},
            {text:"A Book",isCorrect:false},
            {text:"A Skull",isCorrect:true},
        ]
    },
    {
        question:"Which country contains the largest number of active volcanoes?",
        answers:[
            {text:"South Korea",isCorrect:false},
            {text:"India",isCorrect:false},
            {text:"Japan",isCorrect:false},
            {text:"Indonesia",isCorrect:true},
        ]
    },
    {
        question:"Which was the first European country to issue banknotes?",
        answers:[
            {text:"Austria",isCorrect:false},
            {text:"Denmark",isCorrect:false},
            {text:"Sweden",isCorrect:true},
            {text:"Belgium",isCorrect:false},
        ]
    },
    {
        question:"In what year did Rio de Janeiro cease to be the capital of Brazil?",
        answers:[
            {text:"1950",isCorrect:false},
            {text:"1955",isCorrect:false},
            {text:"1960",isCorrect:true},
            {text:"1965",isCorrect:false},
        ]
    },
    {
        question:"Ulaanbaatar is the capital of which country?",
        answers:[
            {text:"Mongolia",isCorrect:true},
            {text:"Kazakhstan",isCorrect:false},
            {text:"Kyrgyzstan",isCorrect:false},
            {text:"Turkmenistan",isCorrect:false},
        ]
    },
    {
        question:"How many muscles does a cat have in each ear?",
        answers:[
            {text:"32",isCorrect:true},
            {text:"48",isCorrect:false},
            {text:"50",isCorrect:false},
            {text:"100",isCorrect:false},
        ]
    }
];